import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortByName',
  standalone: true,
  pure: false
})
export class SortByNamePipe implements PipeTransform {
  //eslint-disable-next-line
  transform<T extends Record<string, any>>(
    array: T[],
    key?: keyof T,
    ascending = true
  ): T[] {
    if (!Array.isArray(array)) return [];
    if (!key) key = 'siteName' as keyof T;

    const sorted = [...array].sort((a, b) => {
      const aValue = String(a[key] ?? '');
      const bValue = String(b[key] ?? '');

      // Split into alternating text and numbers
      const aParts = aValue.split(/(\d+)/).filter(p => p !== '');
      const bParts = bValue.split(/(\d+)/).filter(p => p !== '');

      const len = Math.max(aParts.length, bParts.length);

      for (let i = 0; i < len; i++) {
        const aPart = aParts[i] ?? '';
        const bPart = bParts[i] ?? '';

        const aNum = parseInt(aPart, 10);
        const bNum = parseInt(bPart, 10);

        const aIsNum = !isNaN(aNum);
        const bIsNum = !isNaN(bNum);

        if (aIsNum && bIsNum) {
          if (aNum !== bNum) return aNum - bNum;
        } else if (aIsNum || bIsNum) {
          // numbers come before letters
          return aIsNum ? -1 : 1;
        } else {
          const textCompare = aPart.localeCompare(bPart);
          if (textCompare !== 0) return textCompare;
        }
      }

      return 0; // completely equal
    });

    return ascending ? sorted : sorted.reverse();
  }
}
